module.exports = __webpack_public_path__ + "img/qr.f64c3859.png";